import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import 'isomorphic-fetch'

import './polyfills'

import office from './office/office'
import loft, { appointmentEventLoft } from './services/loft'
import { refreshLocaleData } from './platform/localization'
import { addBreadcrumb } from './sentry-config'
import { initializeAuthMethod } from './office/nested-app-auth/authHelper'

addBreadcrumb({ message: 'Loading APP' })

// IE webview in outlook desktop throws errors
function fixHistory() {
  window.history.pushState = () => {}
  window.history.replaceState = () => {}
}

if (process.env.NODE_ENV === 'development') {
  window['bureau'] = office
  window['devloft'] = () =>
    loft({
      completed: () => {},
      source: { id: '' },
    })
}

// eslint-disable-next-line
;(async () => {
  await refreshLocaleData(navigator.language)
  await office
    .registerCommands({
      loft,
      appointmentEventLoft,
    })
    .initialize()

  await initializeAuthMethod()

  if (!window.location.origin) {
    const port = window.location.port ? `:${window.location.port}` : ''
    // @ts-expect-error "origin" is read-only initially, but we're trying to fix IE here
    window.location.origin = `${window.location.protocol}//${window.location.hostname}${port}`
  }
  fixHistory()

  if (!office.isCommandContext) {
    const { default: mount } = await import('./mount')
    mount()
  }
})()
